module.exports = __webpack_public_path__ + "static/img/combined-top.ba0d5267.png";